export const data = { content:"{\"openapi\":\"3.1.0\",\"info\":{\"title\":\"Documentation API Tracely\",\"description\":\"# Introduction\\n\\nGérez votre livre de police numérique directement avec l'API Tracely.\\n\\n## Authentication\\n\\nToutes les requêtes doivent inclure le token API Tracely dans les en-têtes HTTP comme suit :\\n\\n```Authorization: Bearer [TOKEN]```\\n\\nVous pouvez obtenir votre jeton API directement dans la page API de votre espace d'entreprise.\\n\\n## Base URL\\n\\nVotre URL de base est composée de votre sous-domaine et de l'URL de base de Tracely.\\n`https://{your_subdomain}.tracely.co/api/v1`\\n\\n## Limitation\\n\\nLa limite est réglée sur `60` requêtes par minute. N'hésitez pas à nous contacter si vous avez besoin d'augmenter cette limite.\\n\\n## Response Codes\\n\\nL'API utilise les codes d'état HTTP conventionnels pour signaler si une requête a abouti ou non.\\n\\nEn règle générale, les codes d'état HTTP 2xx indiquent que les opérations ont réussi, les codes 4xx impliquent des échecs liés à l'utilisateur et les codes 5xx suggèrent des problèmes avec l'infrastructure.\\n\\n| Status | Description |\\n| :----: | ------------------------------------------- |\\n| `200`  | Successful request. |\\n| `201`  | Created successfully. |\\n| `401`  | The API key used was missing or invalid.  |\\n| `404`  | The resource was not found. |\\n| `422`  | Check that the parameters were correct. |\\n| `429`  | Too many request. |\\n| `5xx`  | Indicates an error with Tracely.co API servers. |\",\"version\":\"1.0.0\"},\"servers\":[{\"url\":\"https://{your_subdomain}.tracely.co/api/v1\",\"variables\":{\"your_subdomain\":{\"default\":\"demo\",\"description\":\"Sous-domaine client\"}}}],\"security\":[{\"BearerAuth\":[]}],\"paths\":{\"/livres/{book_id}/biens\":{\"post\":{\"operationId\":\"createBookElements\",\"summary\":\"Ajout de bien(s)\",\"description\":\"Le schéma de chaque bien (`book_elements[]`) dépend du **type du livre** référencé par `{book_id}`.\\n- Exemple: *Livre Automobiles* → `AutomobileBookElement`\\n- Exemple: *Livre Objets* → `ObjetBookElement`\\n\\nIl n'est pas possible de mélanger les types de biens dans une même requête. (10 biens par requète maximum)\\n\",\"tags\":[\"Book Elements\"],\"parameters\":[{\"name\":\"book_id\",\"in\":\"path\",\"required\":true,\"description\":\"ID du livre cible (détermine le schéma des biens).\",\"schema\":{\"type\":\"integer\",\"minimum\":1}}],\"requestBody\":{\"required\":true,\"content\":{\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/CreateBookElementsRequestPolymorphic\"},\"examples\":{\"vehicule-json\":{\"summary\":\"Exemple — Livre Automobile - Tiers Particulier\",\"value\":{\"third_party\":{\"type\":\"individual\",\"last_name\":\"Dupont\",\"first_name\":\"Jeanne\",\"address_number\":\"12\",\"address_number_extension\":\"bis\",\"address_street_name\":\"Rue des Fleurs\",\"address_line_2\":\"Bât. A\",\"postal_code\":\"75001\",\"city\":\"Paris\",\"country_code\":\"FR\",\"identity_type\":\"identity_card\",\"identity_issuer\":\"FR\",\"identity_issue_date\":\"2024-05-20\",\"identity_number\":\"ABC123456\"},\"book_elements\":{\"purchase_date\":\"2025-09-10\",\"licence_plate\":\"AB-123-CD\",\"mec\":\"2018-03-15\",\"chassis_number\":\"VF1ABCD1234567890\",\"brand\":\"Renault\",\"type\":\"Clio\",\"model\":\"IV\",\"genre\":\"VP\",\"provenance\":\"FR\",\"color\":\"Bleu\",\"mileage\":\"84500\",\"note\":\"Véhicule propre\",\"is_donation\":false,\"vat_rate\":\"20\",\"vat_type\":\"vat_margin\",\"payments\":{\"amount\":\"5500\",\"payment_method\":\"transfer\",\"payment_date\":\"2025-09-10\"}}}},\"vehicule-2-json\":{\"summary\":\"Exemple — Livre Automobile - Tiers Entreprise\",\"value\":{\"third_party\":{\"type\":\"legal_entity\",\"company\":\"Tracely FR\",\"siret\":\"12345678912345\",\"last_name\":\"Dupont\",\"first_name\":\"Jeanne\",\"address_number\":\"12\",\"address_number_extension\":\"bis\",\"address_street_name\":\"Rue des Fleurs\",\"address_line_2\":\"Bât. A\",\"postal_code\":\"75001\",\"city\":\"Paris\",\"country_code\":\"FR\"},\"book_elements\":{\"purchase_date\":\"2025-09-10\",\"licence_plate\":\"AB-123-CD\",\"mec\":\"2018-03-15\",\"chassis_number\":\"VF1ABCD1234567890\",\"brand\":\"Renault\",\"type\":\"Clio\",\"model\":\"IV\",\"genre\":\"VP\",\"provenance\":\"FR\",\"color\":\"Bleu\",\"mileage\":\"84500\",\"note\":\"Véhicule propre\",\"is_donation\":\"false\",\"vat_rate\":\"20\",\"vat_type\":\"vat_margin\",\"payments\":{\"amount\":\"5500\",\"payment_method\":\"transfer\",\"payment_date\":\"2025-09-10\"}}}},\"objet-json\":{\"summary\":\"Exemple — Livre Objet\",\"value\":{\"third_party\":{\"type\":\"legal_entity\",\"last_name\":\"Martin\",\"first_name\":\"Paul\",\"address_street_name\":\"Avenue des Arts\",\"postal_code\":\"69001\",\"city\":\"Lyon\",\"country_code\":\"FR\",\"identity_type\":\"identity_card\",\"identity_issuer\":\"FR\",\"identity_issue_date\":\"2023-02-02\",\"identity_number\":\"XYZ789123\"},\"book_elements\":{\"designation\":\"Table\",\"description\":\"Table basse en chêne\",\"nature\":\"Mobilier\",\"style\":\"Moderne\",\"seller_third_party_id\":\"42\",\"purchase\":{\"date\":\"2025-09-10\",\"price\":\"199.9\",\"payment_method\":\"transfer\"},\"distinguishing_signs\":\"Signée par l'artisan\",\"dimensions\":{\"unit\":\"cm\",\"width\":\"100\",\"height\":\"45\",\"length\":\"60\"},\"note\":\"Livraison comprise\",\"is_donation\":\"false\",\"vat_rate\":\"20\",\"vat_type\":\"vat_margin\",\"payments\":{\"amount\":\"199.9\",\"payment_method\":\"transfer\",\"payment_date\":\"2025-09-10\"}}}}}},\"multipart/form-data\":{\"schema\":{\"allOf\":[{\"$ref\":\"#/components/schemas/CreateBookElementsRequestPolymorphic\"}]},\"encoding\":{\"book_elements\":{\"style\":\"form\",\"explode\":true}}}}},\"responses\":{\"201\":{\"description\":\"Création réussie\",\"content\":{\"application/json\":{\"schema\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"$ref\":\"#/components/schemas/AutomobileShowBookElement\"}},{\"type\":\"array\",\"items\":{\"$ref\":\"#/components/schemas/ObjectShowBookElement\"}}]}}}},\"422\":{\"description\":\"Erreur de validation\",\"content\":{\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/LaravelValidationError\"},\"examples\":{\"validation-error\":{\"value\":{\"message\":\"Le champ third_party.type est obligatoire.\",\"errors\":{\"third_party.type\":[\"Le champ third_party.type est obligatoire.\"],\"book_elements.0.chassis_number\":[\"Le champ book_elements.0.chassis_number est obligatoire.\"]}}}}}}}}}},\"/livres/{book_id}/biens/{book_element_id}\":{\"get\":{\"operationId\":\"showBookElements\",\"summary\":\"Récupérer un bien\",\"description\":\"Retourne  les informations du bien.\\n\",\"tags\":[\"Book Elements\"],\"responses\":{\"200\":{\"description\":\"Récupération réussie\",\"content\":{\"application/json\":{\"schema\":{\"oneOf\":[{\"$ref\":\"#/components/schemas/AutomobileShowBookElement\"},{\"$ref\":\"#/components/schemas/ObjectShowBookElement\"}]},\"examples\":{\"AutomobileBookElement\":{\"value\":{\"id\":1,\"batch_id\":null,\"order_number\":\"20250913-001\",\"facility_id\":1,\"book_id\":1,\"designation\":\"AB-123-AB • BMW SR220TD\",\"entry_date\":\"2024-03-20T23:00:00.000000Z\",\"exit_date\":null,\"data\":{\"mec\":\"2023-02-23\",\"note\":null,\"type\":\"MC5432PY315\",\"brand\":\"BMW\",\"color\":\"Noir\",\"genre\":\"VP\",\"model\":\"SR220TD\",\"photo\":\"/production/book_elements/tenant-{your_subdomain}/Vc86PtDGjawGz8XdRkttAiEH9tTmCLHAsC8xbtkq.jpg\",\"mileage\":\"32000\",\"provenance\":\"FR\",\"licence_plate\":\"AB-123-AB\",\"chassis_number\":\"VF123456789012345\"},\"accounting\":{\"sales\":{\"fees_amount\":null,\"warranty\":null,\"vat_type\":null,\"vat_rate\":null,\"vat_amount\":null,\"selling_price\":null,\"selling_price_excl_tax\":null,\"invoice_number\":null,\"margin_excl_tax\":null,\"margin_incl_tax\":null},\"purchase\":{\"price\":2000,\"vat_rate\":null,\"vat_type\":null}},\"seller\":{\"id\":141,\"city\":\"Lille\",\"siret\":\"\",\"company\":\"\",\"last_name\":\"Doe\",\"first_name\":\"John\",\"postal_code\":\"59000\",\"country_code\":\"FR\",\"identity_type\":\"identity_card\",\"address_line_2\":\"\",\"address_number\":\"\",\"identity_issuer\":\"FR\",\"identity_number\":\"12345678\",\"address_street_name\":\"du bleu mouton\",\"identity_issue_date\":\"2021-09-11\",\"address_type_of_road\":\"rue\",\"address_number_extension\":\"\"},\"buyer\":null,\"created_at\":\"2024-03-25T20:40:12.000000Z\"}},\"SoldAutomobileBookElement\":{\"value\":{\"id\":1,\"batch_id\":null,\"order_number\":\"20250913-001\",\"facility_id\":1,\"book_id\":1,\"designation\":\"AB-123-AB • BMW SR220TD\",\"entry_date\":\"2024-03-20T23:00:00.000000Z\",\"exit_date\":\"2025-09-12T22:00:00.000000Z\",\"data\":{\"mec\":\"2023-02-23\",\"note\":null,\"type\":\"MC5432PY315\",\"brand\":\"BMW\",\"color\":\"Noir\",\"genre\":\"VP\",\"model\":\"SR220TD\",\"photo\":\"/production/book_elements/tenant-{your_subdomain}/Vc86PtDGjawGz8XdRkttAiEH9tTmCLHAsC8xbtkq.jpg\",\"mileage\":\"32000\",\"provenance\":\"FR\",\"licence_plate\":\"AB-123-AB\",\"chassis_number\":\"VF123456789012345\"},\"accounting\":{\"sales\":{\"fees_amount\":600,\"vat_rate\":20,\"vat_type\":\"vat_margin\",\"vat_amount\":666.6666666666667,\"selling_price\":100000,\"invoice_number\":\"FACT2025-0001\",\"margin_excl_tax\":3333.33,\"margin_incl_tax\":9333.333333333334,\"selling_price_excl_tax\":9333.33},\"purchase\":{\"price\":6000,\"vat_rate\":null,\"vat_type\":null}},\"seller\":{\"id\":141,\"city\":\"Lille\",\"siret\":\"\",\"company\":\"\",\"last_name\":\"Doe\",\"first_name\":\"John\",\"postal_code\":\"59000\",\"country_code\":\"FR\",\"identity_type\":\"identity_card\",\"address_line_2\":\"\",\"address_number\":\"\",\"identity_issuer\":\"FR\",\"identity_number\":\"12345678\",\"address_street_name\":\"du bleu mouton\",\"identity_issue_date\":\"2021-09-11\",\"address_type_of_road\":\"rue\",\"address_number_extension\":\"\"},\"buyer\":{\"id\":141,\"city\":\"Lille\",\"siret\":\"\",\"company\":\"\",\"last_name\":\"Doe\",\"first_name\":\"John\",\"postal_code\":\"59000\",\"country_code\":\"FR\",\"identity_type\":\"identity_card\",\"address_line_2\":\"\",\"address_number\":\"\",\"identity_issuer\":\"FR\",\"identity_number\":\"12345678\",\"address_street_name\":\"du bleu mouton\",\"identity_issue_date\":\"2021-09-11\",\"address_type_of_road\":\"rue\",\"address_number_extension\":\"\"},\"created_at\":\"2024-03-25T20:40:12.000000Z\"}},\"ObjetBookElement\":{\"value\":{\"id\":1,\"batch_id\":null,\"order_number\":\"20250913-001\",\"facility_id\":1,\"book_id\":1,\"designation\":\"Cheminée marbre bl. Turquin l. XVI\",\"entry_date\":\"2024-03-20T23:00:00.000000Z\",\"exit_date\":null,\"data\":{\"note\":null,\"photo\":\"/production/book_elements/tenant-{your_subdomain}/Vc86PtDGjawGz8XdRkttAiEH9tTmCLHAsC8xbtkq.jpg\",\"style\":\"Louis XVI\",\"dimensions\":{\"unit\":\"cm\",\"width\":null,\"height\":null,\"length\":null},\"description\":\"Cheminée marbre bleue turquin 19em\"},\"accounting\":{\"sales\":{\"vat_rate\":null,\"vat_type\":null,\"net_margin\":null,\"vat_amount\":null,\"selling_price\":null,\"invoice_number\":null,\"margin_excl_tax\":null,\"margin_incl_tax\":null},\"purchase\":{\"price\":2000,\"vat_rate\":null,\"vat_type\":null}},\"seller\":{\"id\":141,\"city\":\"Lille\",\"siret\":\"\",\"company\":\"\",\"last_name\":\"Doe\",\"first_name\":\"John\",\"postal_code\":\"59000\",\"country_code\":\"FR\",\"identity_type\":\"identity_card\",\"address_line_2\":\"\",\"address_number\":\"\",\"identity_issuer\":\"FR\",\"identity_number\":\"12345678\",\"address_street_name\":\"du bleu mouton\",\"identity_issue_date\":\"2021-09-11\",\"address_type_of_road\":\"rue\",\"address_number_extension\":\"\"},\"buyer\":null,\"created_at\":\"2024-03-25T20:40:12.000000Z\"}}}}}},\"404\":{\"description\":\"Le bien n'existe pas\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"message\":{\"type\":\"string\"}}},\"examples\":{\"not-found\":{\"value\":{\"message\":\"La resource demandée n'a pas été trouvée.\"}}}}}}}},\"put\":{\"operationId\":\"sellBookElements\",\"summary\":\"Sortir un bien\",\"description\":\"Le schéma de chaque bien (`book_element`) dépend du **type du livre** référencé par `{book_id}`.\\n- Exemple: *Livre Automobiles* → `AutomobileSellBookElement`\\n- Exemple: *Livre Objets* → `ObjetSellBookElement`\\n\",\"tags\":[\"Book Elements\"],\"parameters\":[{\"name\":\"book_id\",\"in\":\"path\",\"required\":true,\"description\":\"ID du livre cible (détermine le schéma des biens).\",\"schema\":{\"type\":\"integer\",\"minimum\":1}},{\"name\":\"book_element_id\",\"in\":\"path\",\"required\":true,\"description\":\"ID du bien cible\",\"schema\":{\"type\":\"integer\",\"minimum\":1}}],\"requestBody\":{\"required\":true,\"content\":{\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/SellBookElementsRequestPolymorphic\"},\"examples\":{\"sell-vehicule-json\":{\"summary\":\"Exemple — Livre Automobile\",\"value\":{\"third_party\":{\"type\":\"individual\",\"last_name\":\"Dupont\",\"first_name\":\"Jeanne\",\"address_number\":\"12\",\"address_number_extension\":\"bis\",\"address_street_name\":\"Rue des Fleurs\",\"address_line_2\":\"Bât. A\",\"postal_code\":\"75001\",\"city\":\"Paris\",\"country_code\":\"FR\",\"identity_type\":\"identity_card\",\"identity_issuer\":\"FR\",\"identity_issue_date\":\"2024-05-20\",\"identity_number\":\"ABC123456\"},\"book_element\":{\"warranty\":6,\"mec\":\"2018-03-15\",\"fees_amount_labor\":600,\"fees_amount_parts\":300,\"vat_type\":\"vat_margin\",\"vat_rate\":\"20\",\"has_new_licence_plate\":1,\"new_licence_plate\":\"AR-100-CA\",\"selling_prince\":30000,\"payment_date\":\"2025-09-10\",\"payment_method\":\"transfer\",\"invoice_number\":\"FACT2025-0001\"}},\"sell-objet-json\":{\"summary\":\"Exemple — Livre Objets\",\"value\":{\"third_party\":{\"type\":\"individual\",\"last_name\":\"Dupont\",\"first_name\":\"Jeanne\",\"address_number\":\"12\",\"address_number_extension\":\"bis\",\"address_street_name\":\"Rue des Fleurs\",\"address_line_2\":\"Bât. A\",\"postal_code\":\"75001\",\"city\":\"Paris\",\"country_code\":\"FR\",\"identity_type\":\"identity_card\",\"identity_issuer\":\"FR\",\"identity_issue_date\":\"2024-05-20\",\"identity_number\":\"ABC123456\"},\"book_element\":{\"vat_type\":\"vat_margin\",\"vat_rate\":\"20\",\"selling_prince\":\"30000\",\"payment_date\":\"2025-09-10\",\"payment_method\":\"transfer\",\"invoice_number\":\"FACT2025-0001\"}}}}}}}}}}},\"components\":{\"securitySchemes\":{\"BearerAuth\":{\"type\":\"http\",\"scheme\":\"bearer\",\"bearerFormat\":\"JWT\"}},\"schemas\":{\"CreateBookElementsRequestPolymorphic\":{\"type\":\"object\",\"required\":[\"third_party\",\"book_elements\"],\"properties\":{\"third_party\":{\"oneOf\":[{\"$ref\":\"#/components/schemas/ThirdPartyIndividual\"},{\"$ref\":\"#/components/schemas/ThirdPartyLegalEntity\"}]},\"book_elements\":{\"type\":\"array\",\"minItems\":1,\"items\":{\"oneOf\":[{\"$ref\":\"#/components/schemas/AutomobileBookElement\"},{\"$ref\":\"#/components/schemas/ObjectBookElement\"}],\"description\":\"Le schéma exact dépend du type du livre ciblé par `{book}`.\\n\"}}}},\"SellBookElementsRequestPolymorphic\":{\"type\":\"object\",\"required\":[\"third_party\",\"book_element\"],\"properties\":{\"third_party\":{\"oneOf\":[{\"$ref\":\"#/components/schemas/ThirdPartyIndividual\"},{\"$ref\":\"#/components/schemas/ThirdPartyLegalEntity\"}]},\"book_element\":{\"oneOf\":[{\"$ref\":\"#/components/schemas/AutomobileSellBookElement\"},{\"$ref\":\"#/components/schemas/ObjetSellBookElement\"}],\"description\":\"Le schéma exact dépend du type du livre ciblé par `{book}`.\\n\"}}},\"ThirdPartyIndividual\":{\"title\":\"Tiers Particulier\",\"type\":\"object\",\"required\":[\"type\",\"last_name\",\"first_name\",\"address_street_name\",\"postal_code\",\"city\",\"country_code\",\"identity_type\",\"identity_issuer\",\"identity_issue_date\",\"identity_number\"],\"properties\":{\"type\":{\"const\":\"individual\"},\"id\":{\"type\":\"integer\",\"nullable\":true,\"description\":\"Si renseigné - aucun tier ne sera recréé et l'existant sera mis à jour avec les informations.\"},\"last_name\":{\"type\":\"string\"},\"first_name\":{\"type\":\"string\"},\"address_number\":{\"type\":\"string\",\"nullable\":true},\"address_number_extension\":{\"type\":\"string\",\"nullable\":true},\"address_street_name\":{\"type\":\"string\"},\"address_line_2\":{\"type\":\"string\",\"nullable\":true},\"postal_code\":{\"type\":\"string\"},\"city\":{\"type\":\"string\"},\"country_code\":{\"type\":\"string\",\"minLength\":2,\"maxLength\":2,\"description\":\"Code pays ISO 3166-1 alpha-2.\"},\"identity_type\":{\"type\":\"string\",\"enum\":[\"identity_card\",\"passport\",\"driving_licence\"]},\"identity_issuer\":{\"type\":\"string\",\"description\":\"Code pays ISO 3166-1 alpha-2 émetteur du titre.\"},\"identity_issue_date\":{\"type\":\"string\",\"format\":\"date\",\"description\":\"Doit être ≤ aujourd'hui.\"},\"identity_number\":{\"type\":\"string\"}}},\"ThirdPartyLegalEntity\":{\"title\":\"Tiers Entreprise\",\"type\":\"object\",\"required\":[\"type\",\"company\",\"address_street_name\",\"postal_code\",\"city\",\"country_code\"],\"properties\":{\"type\":{\"const\":\"legal_entity\"},\"id\":{\"type\":\"integer\",\"nullable\":true,\"description\":\"Si renseigné - aucun tier ne sera recréé et l'existant sera mis à jour avec les informations.\"},\"company\":{\"type\":\"string\"},\"siret\":{\"type\":\"string\",\"nullable\":true,\"description\":\"requis si country_code = FR\"},\"last_name\":{\"type\":\"string\",\"nullable\":true},\"first_name\":{\"type\":\"string\",\"nullable\":true},\"address_number\":{\"type\":\"string\",\"nullable\":true},\"address_number_extension\":{\"type\":\"string\",\"nullable\":true},\"address_street_name\":{\"type\":\"string\"},\"address_line_2\":{\"type\":\"string\",\"nullable\":true},\"postal_code\":{\"type\":\"string\"},\"city\":{\"type\":\"string\"},\"country_code\":{\"type\":\"string\",\"minLength\":2,\"maxLength\":2,\"description\":\"Code pays ISO 3166-1 alpha-2.\"}}},\"Payment\":{\"type\":\"object\",\"required\":[\"amount\",\"payment_date\"],\"properties\":{\"amount\":{\"type\":\"number\"},\"payment_method\":{\"type\":\"string\",\"description\":\"Optionnel, s'il est renseigné doit être dans l'énum.\",\"enum\":[\"card\",\"check\",\"cash\",\"paypal\",\"transfer\"]},\"payment_date\":{\"type\":\"string\",\"format\":\"date\",\"description\":\"Doit être ≤ aujourd'hui.\"}}},\"AutomobileBookElement\":{\"title\":\"AutomobileBookElement\",\"type\":\"object\",\"required\":[\"purchase_date\",\"licence_plate\",\"mec\",\"chassis_number\",\"brand\",\"type\",\"model\",\"genre\",\"provenance\",\"color\",\"mileage\",\"is_donation\",\"vat\",\"payments\"],\"properties\":{\"purchase_date\":{\"type\":\"string\",\"format\":\"date\",\"description\":\"Doit être ≤ aujourd'hui.\"},\"licence_plate\":{\"type\":\"string\",\"description\":\"Champ A sur le CI\"},\"mec\":{\"type\":\"string\",\"format\":\"date\",\"description\":\"Mise en circulation — doit être ≤ aujourd'hui. Champ B sur le CI\"},\"chassis_number\":{\"type\":\"string\",\"minLength\":17,\"maxLength\":17,\"description\":\"Champ E sur le CI (VIN)\"},\"brand\":{\"type\":\"string\",\"description\":\"Champ D.1 sur le CI\"},\"type\":{\"type\":\"string\",\"description\":\"Champ D.2.1 sur le CI\"},\"model\":{\"type\":\"string\",\"description\":\"Champ D.3 sur le CI\"},\"genre\":{\"type\":\"string\",\"enum\":[\"CTTE\",\"CAM\",\"CL\",\"CYCL\",\"MAGA\",\"MTL\",\"MIAR\",\"MTT1\",\"MTT2\",\"QM\",\"REA\",\"RETC\",\"REM\",\"RESP\",\"SREA\",\"SRAT\",\"SRTC\",\"SREM\",\"SRSP\",\"TRA\",\"TRR\",\"TCP\",\"TM\",\"VASP\",\"VP\",\"VTSU\"],\"description\":\"Champ J.1 sur le CI\"},\"provenance\":{\"type\":\"string\",\"description\":\"Code pays ISO 3166-1 alpha-2.\"},\"color\":{\"type\":\"string\"},\"mileage\":{\"type\":\"number\",\"minimum\":0},\"note\":{\"type\":\"string\",\"nullable\":true},\"is_donation\":{\"type\":\"boolean\"},\"vat_rate\":{\"type\":\"string\",\"enum\":[\"0\",\"5.5\",\"10\",\"20\"]},\"vat_type\":{\"type\":\"string\",\"enum\":[\"vat_margin\",\"vat_total_price\",\"vat_exempt\"]},\"payments\":{\"type\":\"array\",\"minItems\":1,\"items\":{\"$ref\":\"#/components/schemas/Payment\"}},\"photo\":{\"type\":\"string\",\"format\":\"binary\",\"nullable\":true,\"description\":\"Image (max ~5 MB). Disponible seulement en multipart/form-data.\"}}},\"ObjectBookElement\":{\"title\":\"ObjectBookElement\",\"type\":\"object\",\"required\":[\"designation\",\"description\",\"is_donation\",\"vat\",\"payments\"],\"properties\":{\"designation\":{\"type\":\"string\",\"description\":\"Désignation de l'objet\"},\"description\":{\"type\":\"string\"},\"dimensions\":{\"type\":\"object\",\"properties\":{\"unit\":{\"type\":\"string\"},\"width\":{\"type\":\"number\"},\"height\":{\"type\":\"number\"},\"length\":{\"type\":\"number\"}}},\"note\":{\"type\":\"string\",\"nullable\":true},\"is_donation\":{\"type\":\"boolean\"},\"vat_rate\":{\"type\":\"string\",\"enum\":[\"0\",\"5.5\",\"10\",\"20\"]},\"vat_type\":{\"type\":\"string\",\"enum\":[\"vat_margin\",\"vat_total_price\",\"vat_exempt\"]},\"payments\":{\"type\":\"array\",\"minItems\":1,\"items\":{\"$ref\":\"#/components/schemas/Payment\"}},\"photo\":{\"type\":\"string\",\"format\":\"binary\",\"nullable\":true,\"description\":\"Image (max ~5 MB). Disponible seulement en multipart/form-data.\"}}},\"AutomobileSellBookElement\":{\"title\":\"AutomobileSellBookElement\",\"type\":\"object\",\"required\":[\"warranty\",\"fees_amount_labor\",\"fees_amount_parts\",\"has_new_licence_plate\",\"selling_price\",\"payment_date\",\"payment_method\",\"vat_type\",\"vat_rate\"],\"properties\":{\"warranty\":{\"type\":\"number\",\"description\":\"Doit être ≥ 0.\"},\"fees_amount_labor\":{\"type\":\"number\",\"description\":\"Doit être ≥ 0.\"},\"fees_amount_parts\":{\"type\":\"number\",\"description\":\"Doit être ≥ 0.\"},\"has_new_licence_plate\":{\"type\":\"boolean\"},\"new_licence_plate\":{\"type\":\"string\"},\"selling_price\":{\"type\":\"number\",\"description\":\"Doit être ≥ 0.\"},\"payment_date\":{\"type\":\"string\",\"format\":\"date\"},\"payment_method\":{\"type\":\"string\",\"enum\":[\"card\",\"transfer\",\"check\"]},\"vat_type\":{\"type\":\"string\",\"enum\":[\"vat_margin\",\"vat_total_price\",\"vat_exempt\"]},\"vat_rate\":{\"type\":\"string\",\"enum\":[\"0\",\"5.5\",\"10\",\"20\"]}}},\"ObjetSellBookElement\":{\"title\":\"ObjetSellBookElement\",\"type\":\"object\",\"required\":[\"selling_price\",\"payment_date\",\"payment_method\",\"vat_type\",\"vat_rate\"],\"properties\":{\"selling_price\":{\"type\":\"number\",\"description\":\"Doit être ≥ 0.\"},\"payment_date\":{\"type\":\"string\",\"format\":\"date\"},\"payment_method\":{\"type\":\"string\",\"enum\":[\"card\",\"transfer\",\"check\"]},\"vat_type\":{\"type\":\"string\",\"enum\":[\"vat_margin\",\"vat_total_price\",\"vat_exempt\"]},\"vat_rate\":{\"type\":\"string\",\"enum\":[\"0\",\"5.5\",\"10\",\"20\"]}}},\"LaravelValidationError\":{\"type\":\"object\",\"properties\":{\"message\":{\"type\":\"string\"},\"errors\":{\"type\":\"object\",\"properties\":{\"propertyName\":{\"type\":\"array\",\"items\":{\"type\":\"string\"}}}}}},\"AutomobileShowBookElement\":{\"title\":\"AutomobileShowBookElement\",\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"integer\"},\"batch_id\":{\"type\":\"string\",\"format\":\"uuid\",\"nullable\":true},\"order_number\":{\"type\":\"string\"},\"facility_id\":{\"type\":\"integer\"},\"book_id\":{\"type\":\"integer\"},\"designation\":{\"type\":\"string\"},\"entry_date\":{\"type\":\"string\",\"format\":\"date-time\"},\"exit_date\":{\"type\":\"string\",\"format\":\"date-time\",\"nullable\":true},\"data\":{\"type\":\"object\",\"properties\":{\"mec\":{\"type\":\"string\",\"format\":\"date\"},\"note\":{\"type\":\"string\",\"nullable\":true},\"type\":{\"type\":\"string\"},\"brand\":{\"type\":\"string\"},\"color\":{\"type\":\"string\"},\"genre\":{\"type\":\"string\",\"enum\":[\"CTTE\",\"CAM\",\"CL\",\"CYCL\",\"MAGA\",\"MTL\",\"MIAR\",\"MTT1\",\"MTT2\",\"QM\",\"REA\",\"RETC\",\"REM\",\"RESP\",\"SREA\",\"SRAT\",\"SRTC\",\"SREM\",\"SRSP\",\"TRA\",\"TRR\",\"TCP\",\"TM\",\"VASP\",\"VP\",\"VTSU\"]},\"model\":{\"type\":\"string\"},\"photo\":{\"type\":\"string\",\"nullable\":true},\"mileage\":{\"type\":\"string\"},\"provenance\":{\"type\":\"string\",\"description\":\"Code pays ISO 3166-1 alpha-2.\"},\"licence_plate\":{\"type\":\"string\"},\"chassis_number\":{\"type\":\"string\"},\"new_licence_plate\":{\"type\":\"string\"}}},\"accounting\":{\"type\":\"object\",\"properties\":{\"sales\":{\"type\":\"object\",\"properties\":{\"vat_rate\":{\"type\":\"string\",\"enum\":[\"0\",\"5.5\",\"10\",\"20\"]},\"vat_type\":{\"type\":\"string\",\"enum\":[\"vat_margin\",\"vat_total_price\",\"vat_exempt\"]},\"net_margin\":{\"type\":\"number\",\"nullable\":true},\"vat_amount\":{\"type\":\"number\",\"nullable\":true},\"selling_price\":{\"type\":\"number\",\"nullable\":true},\"invoice_number\":{\"type\":\"string\",\"nullable\":true},\"margin_excl_tax\":{\"type\":\"number\",\"nullable\":true},\"margin_incl_tax\":{\"type\":\"number\",\"nullable\":true},\"fees_amount_labor\":{\"type\":\"number\",\"nullable\":true},\"fees_amount_parts\":{\"type\":\"number\",\"nullable\":true}}},\"purchase\":{\"type\":\"object\",\"properties\":{\"price\":{\"type\":\"number\",\"nullable\":true},\"vat_rate\":{\"type\":\"string\",\"enum\":[\"0\",\"5.5\",\"10\",\"20\"]}}}}},\"seller\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"integer\"},\"city\":{\"type\":\"string\"},\"siret\":{\"type\":\"string\",\"nullable\":true},\"company\":{\"type\":\"string\",\"nullable\":true},\"last_name\":{\"type\":\"string\",\"nullable\":true},\"first_name\":{\"type\":\"string\",\"nullable\":true},\"postal_code\":{\"type\":\"string\"},\"country_code\":{\"type\":\"string\"},\"identity_type\":{\"type\":\"string\",\"nullable\":true},\"address_line_2\":{\"type\":\"string\",\"nullable\":true},\"address_number\":{\"type\":\"string\",\"nullable\":true},\"identity_issuer\":{\"type\":\"string\",\"nullable\":true},\"identity_number\":{\"type\":\"string\",\"nullable\":true},\"address_street_name\":{\"type\":\"string\"},\"identity_issue_date\":{\"type\":\"string\",\"format\":\"date\",\"nullable\":true},\"address_type_of_road\":{\"type\":\"string\",\"nullable\":true},\"address_number_extension\":{\"type\":\"string\",\"nullable\":true}}},\"buyer\":{\"type\":\"object\",\"nullable\":true,\"properties\":{\"id\":{\"type\":\"integer\"},\"city\":{\"type\":\"string\"},\"siret\":{\"type\":\"string\",\"nullable\":true},\"company\":{\"type\":\"string\",\"nullable\":true},\"last_name\":{\"type\":\"string\",\"nullable\":true},\"first_name\":{\"type\":\"string\",\"nullable\":true},\"postal_code\":{\"type\":\"string\"},\"country_code\":{\"type\":\"string\"},\"identity_type\":{\"type\":\"string\",\"nullable\":true},\"address_line_2\":{\"type\":\"string\",\"nullable\":true},\"address_number\":{\"type\":\"string\",\"nullable\":true},\"identity_issuer\":{\"type\":\"string\",\"nullable\":true},\"identity_number\":{\"type\":\"string\",\"nullable\":true},\"address_street_name\":{\"type\":\"string\"},\"identity_issue_date\":{\"type\":\"string\",\"format\":\"date\",\"nullable\":true},\"address_type_of_road\":{\"type\":\"string\",\"nullable\":true},\"address_number_extension\":{\"type\":\"string\",\"nullable\":true}}},\"created_at\":{\"type\":\"string\",\"format\":\"date-time\"}}},\"ObjectShowBookElement\":{\"title\":\"ObjectShowBookElement\",\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"integer\"},\"batch_id\":{\"type\":\"string\",\"format\":\"uuid\",\"nullable\":true},\"order_number\":{\"type\":\"string\"},\"facility_id\":{\"type\":\"integer\"},\"book_id\":{\"type\":\"integer\"},\"designation\":{\"type\":\"string\"},\"entry_date\":{\"type\":\"string\",\"format\":\"date-time\"},\"exit_date\":{\"type\":\"string\",\"format\":\"date-time\",\"nullable\":true},\"data\":{\"type\":\"object\",\"properties\":{\"note\":{\"type\":\"string\",\"nullable\":true},\"photo\":{\"type\":\"string\",\"nullable\":true},\"style\":{\"type\":\"string\",\"nullable\":true},\"dimensions\":{\"type\":\"object\",\"properties\":{\"unit\":{\"type\":\"string\",\"nullable\":true},\"width\":{\"type\":\"number\",\"nullable\":true},\"height\":{\"type\":\"number\",\"nullable\":true},\"length\":{\"type\":\"number\",\"nullable\":true}}},\"description\":{\"type\":\"string\"}}},\"accounting\":{\"type\":\"object\",\"properties\":{\"sales\":{\"type\":\"object\",\"properties\":{\"vat_rate\":{\"type\":\"number\",\"nullable\":true},\"vat_type\":{\"type\":\"string\",\"enum\":[\"vat_margin\",\"vat_total_price\",\"vat_exempt\"]},\"net_margin\":{\"type\":\"number\",\"nullable\":true},\"vat_amount\":{\"type\":\"number\",\"nullable\":true},\"selling_price\":{\"type\":\"number\",\"nullable\":true},\"invoice_number\":{\"type\":\"string\",\"nullable\":true},\"margin_excl_tax\":{\"type\":\"number\",\"nullable\":true},\"margin_incl_tax\":{\"type\":\"number\",\"nullable\":true}}},\"purchase\":{\"type\":\"object\",\"properties\":{\"price\":{\"type\":\"number\",\"nullable\":true},\"vat_rate\":{\"type\":\"number\",\"nullable\":true}}}}},\"seller\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"integer\"},\"city\":{\"type\":\"string\"},\"siret\":{\"type\":\"string\",\"nullable\":true},\"company\":{\"type\":\"string\",\"nullable\":true},\"last_name\":{\"type\":\"string\",\"nullable\":true},\"first_name\":{\"type\":\"string\",\"nullable\":true},\"postal_code\":{\"type\":\"string\"},\"country_code\":{\"type\":\"string\"},\"identity_type\":{\"type\":\"string\",\"nullable\":true},\"address_line_2\":{\"type\":\"string\",\"nullable\":true},\"address_number\":{\"type\":\"string\",\"nullable\":true},\"identity_issuer\":{\"type\":\"string\",\"nullable\":true},\"identity_number\":{\"type\":\"string\",\"nullable\":true},\"address_street_name\":{\"type\":\"string\"},\"identity_issue_date\":{\"type\":\"string\",\"format\":\"date\",\"nullable\":true},\"address_type_of_road\":{\"type\":\"string\",\"nullable\":true},\"address_number_extension\":{\"type\":\"string\",\"nullable\":true}}},\"buyer\":{\"type\":\"object\",\"nullable\":true,\"properties\":{\"id\":{\"type\":\"integer\"},\"city\":{\"type\":\"string\"},\"siret\":{\"type\":\"string\",\"nullable\":true},\"company\":{\"type\":\"string\",\"nullable\":true},\"last_name\":{\"type\":\"string\",\"nullable\":true},\"first_name\":{\"type\":\"string\",\"nullable\":true},\"postal_code\":{\"type\":\"string\"},\"country_code\":{\"type\":\"string\"},\"identity_type\":{\"type\":\"string\",\"nullable\":true},\"address_line_2\":{\"type\":\"string\",\"nullable\":true},\"address_number\":{\"type\":\"string\",\"nullable\":true},\"identity_issuer\":{\"type\":\"string\",\"nullable\":true},\"identity_number\":{\"type\":\"string\",\"nullable\":true},\"address_street_name\":{\"type\":\"string\"},\"identity_issue_date\":{\"type\":\"string\",\"format\":\"date\",\"nullable\":true},\"address_type_of_road\":{\"type\":\"string\",\"nullable\":true},\"address_number_extension\":{\"type\":\"string\",\"nullable\":true}}},\"created_at\":{\"type\":\"string\",\"format\":\"date-time\"}}}}},\"x-ext-urls\":{}}",
  parsed:{ openapi:"3.1.0",
    info:{ title:"Documentation API Tracely",
      description:"# Introduction\n\nGérez votre livre de police numérique directement avec l'API Tracely.\n\n## Authentication\n\nToutes les requêtes doivent inclure le token API Tracely dans les en-têtes HTTP comme suit :\n\n```Authorization: Bearer [TOKEN]```\n\nVous pouvez obtenir votre jeton API directement dans la page API de votre espace d'entreprise.\n\n## Base URL\n\nVotre URL de base est composée de votre sous-domaine et de l'URL de base de Tracely.\n`https://{your_subdomain}.tracely.co/api/v1`\n\n## Limitation\n\nLa limite est réglée sur `60` requêtes par minute. N'hésitez pas à nous contacter si vous avez besoin d'augmenter cette limite.\n\n## Response Codes\n\nL'API utilise les codes d'état HTTP conventionnels pour signaler si une requête a abouti ou non.\n\nEn règle générale, les codes d'état HTTP 2xx indiquent que les opérations ont réussi, les codes 4xx impliquent des échecs liés à l'utilisateur et les codes 5xx suggèrent des problèmes avec l'infrastructure.\n\n| Status | Description |\n| :----: | ------------------------------------------- |\n| `200`  | Successful request. |\n| `201`  | Created successfully. |\n| `401`  | The API key used was missing or invalid.  |\n| `404`  | The resource was not found. |\n| `422`  | Check that the parameters were correct. |\n| `429`  | Too many request. |\n| `5xx`  | Indicates an error with Tracely.co API servers. |",
      version:"1.0.0" },
    servers:[ { url:"https://{your_subdomain}.tracely.co/api/v1",
        variables:{ your_subdomain:{ "default":"demo",
            description:"Sous-domaine client" } } } ],
    security:[ { BearerAuth:[  ] } ],
    paths:{ "/livres/{book_id}/biens":{ post:{ operationId:"createBookElements",
          summary:"Ajout de bien(s)",
          description:"Le schéma de chaque bien (`book_elements[]`) dépend du **type du livre** référencé par `{book_id}`.\n- Exemple: *Livre Automobiles* → `AutomobileBookElement`\n- Exemple: *Livre Objets* → `ObjetBookElement`\n\nIl n'est pas possible de mélanger les types de biens dans une même requête. (10 biens par requète maximum)\n",
          tags:[ "Book Elements" ],
          parameters:[ { name:"book_id",
              "in":"path",
              required:true,
              description:"ID du livre cible (détermine le schéma des biens).",
              schema:{ type:"integer",
                minimum:1 } } ],
          requestBody:{ required:true,
            content:{ "application/json":{ schema:{ $ref:"#/components/schemas/CreateBookElementsRequestPolymorphic" },
                examples:{ "vehicule-json":{ summary:"Exemple — Livre Automobile - Tiers Particulier",
                    value:{ third_party:{ type:"individual",
                        last_name:"Dupont",
                        first_name:"Jeanne",
                        address_number:"12",
                        address_number_extension:"bis",
                        address_street_name:"Rue des Fleurs",
                        address_line_2:"Bât. A",
                        postal_code:"75001",
                        city:"Paris",
                        country_code:"FR",
                        identity_type:"identity_card",
                        identity_issuer:"FR",
                        identity_issue_date:"2024-05-20",
                        identity_number:"ABC123456" },
                      book_elements:{ purchase_date:"2025-09-10",
                        licence_plate:"AB-123-CD",
                        mec:"2018-03-15",
                        chassis_number:"VF1ABCD1234567890",
                        brand:"Renault",
                        type:"Clio",
                        model:"IV",
                        genre:"VP",
                        provenance:"FR",
                        color:"Bleu",
                        mileage:"84500",
                        note:"Véhicule propre",
                        is_donation:false,
                        vat_rate:"20",
                        vat_type:"vat_margin",
                        payments:{ amount:"5500",
                          payment_method:"transfer",
                          payment_date:"2025-09-10" } } } },
                  "vehicule-2-json":{ summary:"Exemple — Livre Automobile - Tiers Entreprise",
                    value:{ third_party:{ type:"legal_entity",
                        company:"Tracely FR",
                        siret:"12345678912345",
                        last_name:"Dupont",
                        first_name:"Jeanne",
                        address_number:"12",
                        address_number_extension:"bis",
                        address_street_name:"Rue des Fleurs",
                        address_line_2:"Bât. A",
                        postal_code:"75001",
                        city:"Paris",
                        country_code:"FR" },
                      book_elements:{ purchase_date:"2025-09-10",
                        licence_plate:"AB-123-CD",
                        mec:"2018-03-15",
                        chassis_number:"VF1ABCD1234567890",
                        brand:"Renault",
                        type:"Clio",
                        model:"IV",
                        genre:"VP",
                        provenance:"FR",
                        color:"Bleu",
                        mileage:"84500",
                        note:"Véhicule propre",
                        is_donation:"false",
                        vat_rate:"20",
                        vat_type:"vat_margin",
                        payments:{ amount:"5500",
                          payment_method:"transfer",
                          payment_date:"2025-09-10" } } } },
                  "objet-json":{ summary:"Exemple — Livre Objet",
                    value:{ third_party:{ type:"legal_entity",
                        last_name:"Martin",
                        first_name:"Paul",
                        address_street_name:"Avenue des Arts",
                        postal_code:"69001",
                        city:"Lyon",
                        country_code:"FR",
                        identity_type:"identity_card",
                        identity_issuer:"FR",
                        identity_issue_date:"2023-02-02",
                        identity_number:"XYZ789123" },
                      book_elements:{ designation:"Table",
                        description:"Table basse en chêne",
                        nature:"Mobilier",
                        style:"Moderne",
                        seller_third_party_id:"42",
                        purchase:{ date:"2025-09-10",
                          price:"199.9",
                          payment_method:"transfer" },
                        distinguishing_signs:"Signée par l'artisan",
                        dimensions:{ unit:"cm",
                          width:"100",
                          height:"45",
                          length:"60" },
                        note:"Livraison comprise",
                        is_donation:"false",
                        vat_rate:"20",
                        vat_type:"vat_margin",
                        payments:{ amount:"199.9",
                          payment_method:"transfer",
                          payment_date:"2025-09-10" } } } } } },
              "multipart/form-data":{ schema:{ allOf:[ { $ref:"#/components/schemas/CreateBookElementsRequestPolymorphic" } ] },
                encoding:{ book_elements:{ style:"form",
                    explode:true } } } } },
          responses:{ 201:{ description:"Création réussie",
              content:{ "application/json":{ schema:{ oneOf:[ { type:"array",
                        items:{ $ref:"#/components/schemas/AutomobileShowBookElement" } },
                      { type:"array",
                        items:{ $ref:"#/components/schemas/ObjectShowBookElement" } } ] } } } },
            422:{ description:"Erreur de validation",
              content:{ "application/json":{ schema:{ $ref:"#/components/schemas/LaravelValidationError" },
                  examples:{ "validation-error":{ value:{ message:"Le champ third_party.type est obligatoire.",
                        errors:{ "third_party.type":[ "Le champ third_party.type est obligatoire." ],
                          "book_elements.0.chassis_number":[ "Le champ book_elements.0.chassis_number est obligatoire." ] } } } } } } } } } },
      "/livres/{book_id}/biens/{book_element_id}":{ get:{ operationId:"showBookElements",
          summary:"Récupérer un bien",
          description:"Retourne  les informations du bien.\n",
          tags:[ "Book Elements" ],
          responses:{ 200:{ description:"Récupération réussie",
              content:{ "application/json":{ schema:{ oneOf:[ { $ref:"#/components/schemas/AutomobileShowBookElement" },
                      { $ref:"#/components/schemas/ObjectShowBookElement" } ] },
                  examples:{ AutomobileBookElement:{ value:{ id:1,
                        batch_id:null,
                        order_number:"20250913-001",
                        facility_id:1,
                        book_id:1,
                        designation:"AB-123-AB • BMW SR220TD",
                        entry_date:"2024-03-20T23:00:00.000000Z",
                        exit_date:null,
                        data:{ mec:"2023-02-23",
                          note:null,
                          type:"MC5432PY315",
                          brand:"BMW",
                          color:"Noir",
                          genre:"VP",
                          model:"SR220TD",
                          photo:"/production/book_elements/tenant-{your_subdomain}/Vc86PtDGjawGz8XdRkttAiEH9tTmCLHAsC8xbtkq.jpg",
                          mileage:"32000",
                          provenance:"FR",
                          licence_plate:"AB-123-AB",
                          chassis_number:"VF123456789012345" },
                        accounting:{ sales:{ fees_amount:null,
                            warranty:null,
                            vat_type:null,
                            vat_rate:null,
                            vat_amount:null,
                            selling_price:null,
                            selling_price_excl_tax:null,
                            invoice_number:null,
                            margin_excl_tax:null,
                            margin_incl_tax:null },
                          purchase:{ price:2000,
                            vat_rate:null,
                            vat_type:null } },
                        seller:{ id:141,
                          city:"Lille",
                          siret:"",
                          company:"",
                          last_name:"Doe",
                          first_name:"John",
                          postal_code:"59000",
                          country_code:"FR",
                          identity_type:"identity_card",
                          address_line_2:"",
                          address_number:"",
                          identity_issuer:"FR",
                          identity_number:"12345678",
                          address_street_name:"du bleu mouton",
                          identity_issue_date:"2021-09-11",
                          address_type_of_road:"rue",
                          address_number_extension:"" },
                        buyer:null,
                        created_at:"2024-03-25T20:40:12.000000Z" } },
                    SoldAutomobileBookElement:{ value:{ id:1,
                        batch_id:null,
                        order_number:"20250913-001",
                        facility_id:1,
                        book_id:1,
                        designation:"AB-123-AB • BMW SR220TD",
                        entry_date:"2024-03-20T23:00:00.000000Z",
                        exit_date:"2025-09-12T22:00:00.000000Z",
                        data:{ mec:"2023-02-23",
                          note:null,
                          type:"MC5432PY315",
                          brand:"BMW",
                          color:"Noir",
                          genre:"VP",
                          model:"SR220TD",
                          photo:"/production/book_elements/tenant-{your_subdomain}/Vc86PtDGjawGz8XdRkttAiEH9tTmCLHAsC8xbtkq.jpg",
                          mileage:"32000",
                          provenance:"FR",
                          licence_plate:"AB-123-AB",
                          chassis_number:"VF123456789012345" },
                        accounting:{ sales:{ fees_amount:600,
                            vat_rate:20,
                            vat_type:"vat_margin",
                            vat_amount:666.6666666666667,
                            selling_price:100000,
                            invoice_number:"FACT2025-0001",
                            margin_excl_tax:3333.33,
                            margin_incl_tax:9333.333333333334,
                            selling_price_excl_tax:9333.33 },
                          purchase:{ price:6000,
                            vat_rate:null,
                            vat_type:null } },
                        seller:{ id:141,
                          city:"Lille",
                          siret:"",
                          company:"",
                          last_name:"Doe",
                          first_name:"John",
                          postal_code:"59000",
                          country_code:"FR",
                          identity_type:"identity_card",
                          address_line_2:"",
                          address_number:"",
                          identity_issuer:"FR",
                          identity_number:"12345678",
                          address_street_name:"du bleu mouton",
                          identity_issue_date:"2021-09-11",
                          address_type_of_road:"rue",
                          address_number_extension:"" },
                        buyer:{ id:141,
                          city:"Lille",
                          siret:"",
                          company:"",
                          last_name:"Doe",
                          first_name:"John",
                          postal_code:"59000",
                          country_code:"FR",
                          identity_type:"identity_card",
                          address_line_2:"",
                          address_number:"",
                          identity_issuer:"FR",
                          identity_number:"12345678",
                          address_street_name:"du bleu mouton",
                          identity_issue_date:"2021-09-11",
                          address_type_of_road:"rue",
                          address_number_extension:"" },
                        created_at:"2024-03-25T20:40:12.000000Z" } },
                    ObjetBookElement:{ value:{ id:1,
                        batch_id:null,
                        order_number:"20250913-001",
                        facility_id:1,
                        book_id:1,
                        designation:"Cheminée marbre bl. Turquin l. XVI",
                        entry_date:"2024-03-20T23:00:00.000000Z",
                        exit_date:null,
                        data:{ note:null,
                          photo:"/production/book_elements/tenant-{your_subdomain}/Vc86PtDGjawGz8XdRkttAiEH9tTmCLHAsC8xbtkq.jpg",
                          style:"Louis XVI",
                          dimensions:{ unit:"cm",
                            width:null,
                            height:null,
                            length:null },
                          description:"Cheminée marbre bleue turquin 19em" },
                        accounting:{ sales:{ vat_rate:null,
                            vat_type:null,
                            net_margin:null,
                            vat_amount:null,
                            selling_price:null,
                            invoice_number:null,
                            margin_excl_tax:null,
                            margin_incl_tax:null },
                          purchase:{ price:2000,
                            vat_rate:null,
                            vat_type:null } },
                        seller:{ id:141,
                          city:"Lille",
                          siret:"",
                          company:"",
                          last_name:"Doe",
                          first_name:"John",
                          postal_code:"59000",
                          country_code:"FR",
                          identity_type:"identity_card",
                          address_line_2:"",
                          address_number:"",
                          identity_issuer:"FR",
                          identity_number:"12345678",
                          address_street_name:"du bleu mouton",
                          identity_issue_date:"2021-09-11",
                          address_type_of_road:"rue",
                          address_number_extension:"" },
                        buyer:null,
                        created_at:"2024-03-25T20:40:12.000000Z" } } } } } },
            404:{ description:"Le bien n'existe pas",
              content:{ "application/json":{ schema:{ type:"object",
                    properties:{ message:{ type:"string" } } },
                  examples:{ "not-found":{ value:{ message:"La resource demandée n'a pas été trouvée." } } } } } } } },
        put:{ operationId:"sellBookElements",
          summary:"Sortir un bien",
          description:"Le schéma de chaque bien (`book_element`) dépend du **type du livre** référencé par `{book_id}`.\n- Exemple: *Livre Automobiles* → `AutomobileSellBookElement`\n- Exemple: *Livre Objets* → `ObjetSellBookElement`\n",
          tags:[ "Book Elements" ],
          parameters:[ { name:"book_id",
              "in":"path",
              required:true,
              description:"ID du livre cible (détermine le schéma des biens).",
              schema:{ type:"integer",
                minimum:1 } },
            { name:"book_element_id",
              "in":"path",
              required:true,
              description:"ID du bien cible",
              schema:{ type:"integer",
                minimum:1 } } ],
          requestBody:{ required:true,
            content:{ "application/json":{ schema:{ $ref:"#/components/schemas/SellBookElementsRequestPolymorphic" },
                examples:{ "sell-vehicule-json":{ summary:"Exemple — Livre Automobile",
                    value:{ third_party:{ type:"individual",
                        last_name:"Dupont",
                        first_name:"Jeanne",
                        address_number:"12",
                        address_number_extension:"bis",
                        address_street_name:"Rue des Fleurs",
                        address_line_2:"Bât. A",
                        postal_code:"75001",
                        city:"Paris",
                        country_code:"FR",
                        identity_type:"identity_card",
                        identity_issuer:"FR",
                        identity_issue_date:"2024-05-20",
                        identity_number:"ABC123456" },
                      book_element:{ warranty:6,
                        mec:"2018-03-15",
                        fees_amount_labor:600,
                        fees_amount_parts:300,
                        vat_type:"vat_margin",
                        vat_rate:"20",
                        has_new_licence_plate:1,
                        new_licence_plate:"AR-100-CA",
                        selling_prince:30000,
                        payment_date:"2025-09-10",
                        payment_method:"transfer",
                        invoice_number:"FACT2025-0001" } },
                    "sell-objet-json":{ summary:"Exemple — Livre Objets",
                      value:{ third_party:{ type:"individual",
                          last_name:"Dupont",
                          first_name:"Jeanne",
                          address_number:"12",
                          address_number_extension:"bis",
                          address_street_name:"Rue des Fleurs",
                          address_line_2:"Bât. A",
                          postal_code:"75001",
                          city:"Paris",
                          country_code:"FR",
                          identity_type:"identity_card",
                          identity_issuer:"FR",
                          identity_issue_date:"2024-05-20",
                          identity_number:"ABC123456" },
                        book_element:{ vat_type:"vat_margin",
                          vat_rate:"20",
                          selling_prince:"30000",
                          payment_date:"2025-09-10",
                          payment_method:"transfer",
                          invoice_number:"FACT2025-0001" } } } } } } } } } } },
    components:{ securitySchemes:{ BearerAuth:{ type:"http",
          scheme:"bearer",
          bearerFormat:"JWT" } },
      schemas:{ CreateBookElementsRequestPolymorphic:{ type:"object",
          required:[ "third_party",
            "book_elements" ],
          properties:{ third_party:{ oneOf:[ { $ref:"#/components/schemas/ThirdPartyIndividual" },
                { $ref:"#/components/schemas/ThirdPartyLegalEntity" } ] },
            book_elements:{ type:"array",
              minItems:1,
              items:{ oneOf:[ { $ref:"#/components/schemas/AutomobileBookElement" },
                  { $ref:"#/components/schemas/ObjectBookElement" } ],
                description:"Le schéma exact dépend du type du livre ciblé par `{book}`.\n" } } } },
        SellBookElementsRequestPolymorphic:{ type:"object",
          required:[ "third_party",
            "book_element" ],
          properties:{ third_party:{ oneOf:[ { $ref:"#/components/schemas/ThirdPartyIndividual" },
                { $ref:"#/components/schemas/ThirdPartyLegalEntity" } ] },
            book_element:{ oneOf:[ { $ref:"#/components/schemas/AutomobileSellBookElement" },
                { $ref:"#/components/schemas/ObjetSellBookElement" } ],
              description:"Le schéma exact dépend du type du livre ciblé par `{book}`.\n" } } },
        ThirdPartyIndividual:{ title:"Tiers Particulier",
          type:"object",
          required:[ "type",
            "last_name",
            "first_name",
            "address_street_name",
            "postal_code",
            "city",
            "country_code",
            "identity_type",
            "identity_issuer",
            "identity_issue_date",
            "identity_number" ],
          properties:{ type:{ "const":"individual" },
            id:{ type:"integer",
              nullable:true,
              description:"Si renseigné - aucun tier ne sera recréé et l'existant sera mis à jour avec les informations." },
            last_name:{ type:"string" },
            first_name:{ type:"string" },
            address_number:{ type:"string",
              nullable:true },
            address_number_extension:{ type:"string",
              nullable:true },
            address_street_name:{ type:"string" },
            address_line_2:{ type:"string",
              nullable:true },
            postal_code:{ type:"string" },
            city:{ type:"string" },
            country_code:{ type:"string",
              minLength:2,
              maxLength:2,
              description:"Code pays ISO 3166-1 alpha-2." },
            identity_type:{ type:"string",
              "enum":[ "identity_card",
                "passport",
                "driving_licence" ] },
            identity_issuer:{ type:"string",
              description:"Code pays ISO 3166-1 alpha-2 émetteur du titre." },
            identity_issue_date:{ type:"string",
              format:"date",
              description:"Doit être ≤ aujourd'hui." },
            identity_number:{ type:"string" } } },
        ThirdPartyLegalEntity:{ title:"Tiers Entreprise",
          type:"object",
          required:[ "type",
            "company",
            "address_street_name",
            "postal_code",
            "city",
            "country_code" ],
          properties:{ type:{ "const":"legal_entity" },
            id:{ type:"integer",
              nullable:true,
              description:"Si renseigné - aucun tier ne sera recréé et l'existant sera mis à jour avec les informations." },
            company:{ type:"string" },
            siret:{ type:"string",
              nullable:true,
              description:"requis si country_code = FR" },
            last_name:{ type:"string",
              nullable:true },
            first_name:{ type:"string",
              nullable:true },
            address_number:{ type:"string",
              nullable:true },
            address_number_extension:{ type:"string",
              nullable:true },
            address_street_name:{ type:"string" },
            address_line_2:{ type:"string",
              nullable:true },
            postal_code:{ type:"string" },
            city:{ type:"string" },
            country_code:{ type:"string",
              minLength:2,
              maxLength:2,
              description:"Code pays ISO 3166-1 alpha-2." } } },
        Payment:{ type:"object",
          required:[ "amount",
            "payment_date" ],
          properties:{ amount:{ type:"number" },
            payment_method:{ type:"string",
              description:"Optionnel, s'il est renseigné doit être dans l'énum.",
              "enum":[ "card",
                "check",
                "cash",
                "paypal",
                "transfer" ] },
            payment_date:{ type:"string",
              format:"date",
              description:"Doit être ≤ aujourd'hui." } } },
        AutomobileBookElement:{ title:"AutomobileBookElement",
          type:"object",
          required:[ "purchase_date",
            "licence_plate",
            "mec",
            "chassis_number",
            "brand",
            "type",
            "model",
            "genre",
            "provenance",
            "color",
            "mileage",
            "is_donation",
            "vat",
            "payments" ],
          properties:{ purchase_date:{ type:"string",
              format:"date",
              description:"Doit être ≤ aujourd'hui." },
            licence_plate:{ type:"string",
              description:"Champ A sur le CI" },
            mec:{ type:"string",
              format:"date",
              description:"Mise en circulation — doit être ≤ aujourd'hui. Champ B sur le CI" },
            chassis_number:{ type:"string",
              minLength:17,
              maxLength:17,
              description:"Champ E sur le CI (VIN)" },
            brand:{ type:"string",
              description:"Champ D.1 sur le CI" },
            type:{ type:"string",
              description:"Champ D.2.1 sur le CI" },
            model:{ type:"string",
              description:"Champ D.3 sur le CI" },
            genre:{ type:"string",
              "enum":[ "CTTE",
                "CAM",
                "CL",
                "CYCL",
                "MAGA",
                "MTL",
                "MIAR",
                "MTT1",
                "MTT2",
                "QM",
                "REA",
                "RETC",
                "REM",
                "RESP",
                "SREA",
                "SRAT",
                "SRTC",
                "SREM",
                "SRSP",
                "TRA",
                "TRR",
                "TCP",
                "TM",
                "VASP",
                "VP",
                "VTSU" ],
              description:"Champ J.1 sur le CI" },
            provenance:{ type:"string",
              description:"Code pays ISO 3166-1 alpha-2." },
            color:{ type:"string" },
            mileage:{ type:"number",
              minimum:0 },
            note:{ type:"string",
              nullable:true },
            is_donation:{ type:"boolean" },
            vat_rate:{ type:"string",
              "enum":[ "0",
                "5.5",
                "10",
                "20" ] },
            vat_type:{ type:"string",
              "enum":[ "vat_margin",
                "vat_total_price",
                "vat_exempt" ] },
            payments:{ type:"array",
              minItems:1,
              items:{ $ref:"#/components/schemas/Payment" } },
            photo:{ type:"string",
              format:"binary",
              nullable:true,
              description:"Image (max ~5 MB). Disponible seulement en multipart/form-data." } } },
        ObjectBookElement:{ title:"ObjectBookElement",
          type:"object",
          required:[ "designation",
            "description",
            "is_donation",
            "vat",
            "payments" ],
          properties:{ designation:{ type:"string",
              description:"Désignation de l'objet" },
            description:{ type:"string" },
            dimensions:{ type:"object",
              properties:{ unit:{ type:"string" },
                width:{ type:"number" },
                height:{ type:"number" },
                length:{ type:"number" } } },
            note:{ type:"string",
              nullable:true },
            is_donation:{ type:"boolean" },
            vat_rate:{ type:"string",
              "enum":[ "0",
                "5.5",
                "10",
                "20" ] },
            vat_type:{ type:"string",
              "enum":[ "vat_margin",
                "vat_total_price",
                "vat_exempt" ] },
            payments:{ type:"array",
              minItems:1,
              items:{ $ref:"#/components/schemas/Payment" } },
            photo:{ type:"string",
              format:"binary",
              nullable:true,
              description:"Image (max ~5 MB). Disponible seulement en multipart/form-data." } } },
        AutomobileSellBookElement:{ title:"AutomobileSellBookElement",
          type:"object",
          required:[ "warranty",
            "fees_amount_labor",
            "fees_amount_parts",
            "has_new_licence_plate",
            "selling_price",
            "payment_date",
            "payment_method",
            "vat_type",
            "vat_rate" ],
          properties:{ warranty:{ type:"number",
              description:"Doit être ≥ 0." },
            fees_amount_labor:{ type:"number",
              description:"Doit être ≥ 0." },
            fees_amount_parts:{ type:"number",
              description:"Doit être ≥ 0." },
            has_new_licence_plate:{ type:"boolean" },
            new_licence_plate:{ type:"string" },
            selling_price:{ type:"number",
              description:"Doit être ≥ 0." },
            payment_date:{ type:"string",
              format:"date" },
            payment_method:{ type:"string",
              "enum":[ "card",
                "transfer",
                "check" ] },
            vat_type:{ type:"string",
              "enum":[ "vat_margin",
                "vat_total_price",
                "vat_exempt" ] },
            vat_rate:{ type:"string",
              "enum":[ "0",
                "5.5",
                "10",
                "20" ] } } },
        ObjetSellBookElement:{ title:"ObjetSellBookElement",
          type:"object",
          required:[ "selling_price",
            "payment_date",
            "payment_method",
            "vat_type",
            "vat_rate" ],
          properties:{ selling_price:{ type:"number",
              description:"Doit être ≥ 0." },
            payment_date:{ type:"string",
              format:"date" },
            payment_method:{ type:"string",
              "enum":[ "card",
                "transfer",
                "check" ] },
            vat_type:{ type:"string",
              "enum":[ "vat_margin",
                "vat_total_price",
                "vat_exempt" ] },
            vat_rate:{ type:"string",
              "enum":[ "0",
                "5.5",
                "10",
                "20" ] } } },
        LaravelValidationError:{ type:"object",
          properties:{ message:{ type:"string" },
            errors:{ type:"object",
              properties:{ propertyName:{ type:"array",
                  items:{ type:"string" } } } } } },
        AutomobileShowBookElement:{ title:"AutomobileShowBookElement",
          type:"object",
          properties:{ id:{ type:"integer" },
            batch_id:{ type:"string",
              format:"uuid",
              nullable:true },
            order_number:{ type:"string" },
            facility_id:{ type:"integer" },
            book_id:{ type:"integer" },
            designation:{ type:"string" },
            entry_date:{ type:"string",
              format:"date-time" },
            exit_date:{ type:"string",
              format:"date-time",
              nullable:true },
            data:{ type:"object",
              properties:{ mec:{ type:"string",
                  format:"date" },
                note:{ type:"string",
                  nullable:true },
                type:{ type:"string" },
                brand:{ type:"string" },
                color:{ type:"string" },
                genre:{ type:"string",
                  "enum":[ "CTTE",
                    "CAM",
                    "CL",
                    "CYCL",
                    "MAGA",
                    "MTL",
                    "MIAR",
                    "MTT1",
                    "MTT2",
                    "QM",
                    "REA",
                    "RETC",
                    "REM",
                    "RESP",
                    "SREA",
                    "SRAT",
                    "SRTC",
                    "SREM",
                    "SRSP",
                    "TRA",
                    "TRR",
                    "TCP",
                    "TM",
                    "VASP",
                    "VP",
                    "VTSU" ] },
                model:{ type:"string" },
                photo:{ type:"string",
                  nullable:true },
                mileage:{ type:"string" },
                provenance:{ type:"string",
                  description:"Code pays ISO 3166-1 alpha-2." },
                licence_plate:{ type:"string" },
                chassis_number:{ type:"string" },
                new_licence_plate:{ type:"string" } } },
            accounting:{ type:"object",
              properties:{ sales:{ type:"object",
                  properties:{ vat_rate:{ type:"string",
                      "enum":[ "0",
                        "5.5",
                        "10",
                        "20" ] },
                    vat_type:{ type:"string",
                      "enum":[ "vat_margin",
                        "vat_total_price",
                        "vat_exempt" ] },
                    net_margin:{ type:"number",
                      nullable:true },
                    vat_amount:{ type:"number",
                      nullable:true },
                    selling_price:{ type:"number",
                      nullable:true },
                    invoice_number:{ type:"string",
                      nullable:true },
                    margin_excl_tax:{ type:"number",
                      nullable:true },
                    margin_incl_tax:{ type:"number",
                      nullable:true },
                    fees_amount_labor:{ type:"number",
                      nullable:true },
                    fees_amount_parts:{ type:"number",
                      nullable:true } } },
                purchase:{ type:"object",
                  properties:{ price:{ type:"number",
                      nullable:true },
                    vat_rate:{ type:"string",
                      "enum":[ "0",
                        "5.5",
                        "10",
                        "20" ] } } } } },
            seller:{ type:"object",
              properties:{ id:{ type:"integer" },
                city:{ type:"string" },
                siret:{ type:"string",
                  nullable:true },
                company:{ type:"string",
                  nullable:true },
                last_name:{ type:"string",
                  nullable:true },
                first_name:{ type:"string",
                  nullable:true },
                postal_code:{ type:"string" },
                country_code:{ type:"string" },
                identity_type:{ type:"string",
                  nullable:true },
                address_line_2:{ type:"string",
                  nullable:true },
                address_number:{ type:"string",
                  nullable:true },
                identity_issuer:{ type:"string",
                  nullable:true },
                identity_number:{ type:"string",
                  nullable:true },
                address_street_name:{ type:"string" },
                identity_issue_date:{ type:"string",
                  format:"date",
                  nullable:true },
                address_type_of_road:{ type:"string",
                  nullable:true },
                address_number_extension:{ type:"string",
                  nullable:true } } },
            buyer:{ type:"object",
              nullable:true,
              properties:{ id:{ type:"integer" },
                city:{ type:"string" },
                siret:{ type:"string",
                  nullable:true },
                company:{ type:"string",
                  nullable:true },
                last_name:{ type:"string",
                  nullable:true },
                first_name:{ type:"string",
                  nullable:true },
                postal_code:{ type:"string" },
                country_code:{ type:"string" },
                identity_type:{ type:"string",
                  nullable:true },
                address_line_2:{ type:"string",
                  nullable:true },
                address_number:{ type:"string",
                  nullable:true },
                identity_issuer:{ type:"string",
                  nullable:true },
                identity_number:{ type:"string",
                  nullable:true },
                address_street_name:{ type:"string" },
                identity_issue_date:{ type:"string",
                  format:"date",
                  nullable:true },
                address_type_of_road:{ type:"string",
                  nullable:true },
                address_number_extension:{ type:"string",
                  nullable:true } } },
            created_at:{ type:"string",
              format:"date-time" } } },
        ObjectShowBookElement:{ title:"ObjectShowBookElement",
          type:"object",
          properties:{ id:{ type:"integer" },
            batch_id:{ type:"string",
              format:"uuid",
              nullable:true },
            order_number:{ type:"string" },
            facility_id:{ type:"integer" },
            book_id:{ type:"integer" },
            designation:{ type:"string" },
            entry_date:{ type:"string",
              format:"date-time" },
            exit_date:{ type:"string",
              format:"date-time",
              nullable:true },
            data:{ type:"object",
              properties:{ note:{ type:"string",
                  nullable:true },
                photo:{ type:"string",
                  nullable:true },
                style:{ type:"string",
                  nullable:true },
                dimensions:{ type:"object",
                  properties:{ unit:{ type:"string",
                      nullable:true },
                    width:{ type:"number",
                      nullable:true },
                    height:{ type:"number",
                      nullable:true },
                    length:{ type:"number",
                      nullable:true } } },
                description:{ type:"string" } } },
            accounting:{ type:"object",
              properties:{ sales:{ type:"object",
                  properties:{ vat_rate:{ type:"number",
                      nullable:true },
                    vat_type:{ type:"string",
                      "enum":[ "vat_margin",
                        "vat_total_price",
                        "vat_exempt" ] },
                    net_margin:{ type:"number",
                      nullable:true },
                    vat_amount:{ type:"number",
                      nullable:true },
                    selling_price:{ type:"number",
                      nullable:true },
                    invoice_number:{ type:"string",
                      nullable:true },
                    margin_excl_tax:{ type:"number",
                      nullable:true },
                    margin_incl_tax:{ type:"number",
                      nullable:true } } },
                purchase:{ type:"object",
                  properties:{ price:{ type:"number",
                      nullable:true },
                    vat_rate:{ type:"number",
                      nullable:true } } } } },
            seller:{ type:"object",
              properties:{ id:{ type:"integer" },
                city:{ type:"string" },
                siret:{ type:"string",
                  nullable:true },
                company:{ type:"string",
                  nullable:true },
                last_name:{ type:"string",
                  nullable:true },
                first_name:{ type:"string",
                  nullable:true },
                postal_code:{ type:"string" },
                country_code:{ type:"string" },
                identity_type:{ type:"string",
                  nullable:true },
                address_line_2:{ type:"string",
                  nullable:true },
                address_number:{ type:"string",
                  nullable:true },
                identity_issuer:{ type:"string",
                  nullable:true },
                identity_number:{ type:"string",
                  nullable:true },
                address_street_name:{ type:"string" },
                identity_issue_date:{ type:"string",
                  format:"date",
                  nullable:true },
                address_type_of_road:{ type:"string",
                  nullable:true },
                address_number_extension:{ type:"string",
                  nullable:true } } },
            buyer:{ type:"object",
              nullable:true,
              properties:{ id:{ type:"integer" },
                city:{ type:"string" },
                siret:{ type:"string",
                  nullable:true },
                company:{ type:"string",
                  nullable:true },
                last_name:{ type:"string",
                  nullable:true },
                first_name:{ type:"string",
                  nullable:true },
                postal_code:{ type:"string" },
                country_code:{ type:"string" },
                identity_type:{ type:"string",
                  nullable:true },
                address_line_2:{ type:"string",
                  nullable:true },
                address_number:{ type:"string",
                  nullable:true },
                identity_issuer:{ type:"string",
                  nullable:true },
                identity_number:{ type:"string",
                  nullable:true },
                address_street_name:{ type:"string" },
                identity_issue_date:{ type:"string",
                  format:"date",
                  nullable:true },
                address_type_of_road:{ type:"string",
                  nullable:true },
                address_number_extension:{ type:"string",
                  nullable:true } } },
            created_at:{ type:"string",
              format:"date-time" } } } } },
    "x-ext-urls":{} } }